module.exports = __webpack_public_path__ + "img/count.1fa6471e.png";